class ButtonFilters extends HTMLElement {
  constructor() {
    super();
    this.btns = this.querySelectorAll('.button-filters__btn');

    this.btns.forEach(btn => btn.addEventListener('click', this.onBtnClick.bind(this)));
  }

  onBtnClick(e) {
    const btn = e.target.classList.contains('button-filters__btn') ? e.target : e.target.closest('.button-filters__btn');
    const relatedFilter = document.querySelector(`.mobile-facets ${btn.dataset.filter}`).querySelector('summary');
    const filterDrawerBtn = document.querySelector('.mobile-facets__wrapper').querySelector('summary');

    // 1. Open filter drawer
    filterDrawerBtn.click();

    // 2. Open related filter
    relatedFilter.click();
  }
}

customElements.define('button-filters', ButtonFilters);